'use client'

import { useAtom } from 'jotai'
import { useEffect } from 'react'

import { presetTourAtom } from '@/state/preset-tour'

/**
 * Advances the preset tour from 'quantity' to 'save' once the amount input it's
 * pointing at gets a real value. Lives in the two leaf amount-input components
 * (input-with-ticker-list.tsx / input-with-contract.tsx) rather than being
 * driven from unified-order-form.tsx — that hook's value/onValueChange plumbing
 * is shared by multi-leg groups and denomination handling, not a good place to
 * bolt tour-only concerns onto.
 */
export function useAdvancePresetTourOnQuantity(value: string) {
  const [tour, setTour] = useAtom(presetTourAtom)

  useEffect(() => {
    if (tour?.step !== 'quantity') return
    if (!value || value === '0') return
    setTour({ ...tour, step: 'save' })
  }, [value, tour, setTour])
}
